import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import Model from './ModelBdevent.mjs'

export const FormItemEventTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="eventTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseBdevent(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdName />
            <FormItemBdNo />
            <FormItemEventTitle />
        </FormChooseDesign>
    )
}
